import { graphql } from "gatsby"
import React from "react"
import {
  gebruikersVoorwaarden,
  download,
} from "./algemenevoorwaarden.module.css"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"

/* Components */
import Seo from "../components/seo/seo"
import Layout from "../components/layout"
import Footer from "../components/footer/footer"

/* Components */
import StickyNav from "../components/sticky-nav/sticky-nav"

const AlgemeneVoorwaarden = ({ data }) => {
  const navigationDesks = data.navigationDesks.nodes;
  return (
    <Layout>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.mkbservicedesk.nl/algemene-voorwaarden/"
        />
      </Helmet>
      <header className="header">
        <StickyNav desks={navigationDesks} />
      </header>
      <main className="main">
        <div className="container">
          <Seo title="Gebruiksvoorwaarden website MKB Servicedesk" />
          <div className={gebruikersVoorwaarden}>
            <h1>Gebruiksvoorwaarden website MKB Servicedesk</h1>
            <p>De meest actuele algemene voorwaarden kun je downloaden via de onderstaande button.</p>
            <Link
              className={download}
              to="https://www.mkbservicedesk.nl/documenten/algemene-voorwaarden.pdf"
            >
              Download
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </Layout>
  )
}

export default AlgemeneVoorwaarden

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }

    navigationDesks: allContentfulDesk(sort: { fields: sortNavigation }) {
      nodes {
        id
        name
        slug2
        sortNavigation
        ctaNavigation {
          image {
            title
            gatsbyImageData(layout: CONSTRAINED, width: 1180)
          }
          title
          slug
          categories {
            slug2
            desk {
              slug2
            }
          }
        }
        deskcategory {
          id
          name
          slug2
          article {
            id
            title
            slug2
            updateDate
            categories {
              slug2
              desk {
                slug2
              }
            }
          }
        }
      }
    }
  }
`
